import { createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import { IEntityState, buildFeatureState } from '@briebug/ngrx-auto-entity';
import { Type } from '@angular/core';
import { Todo } from './todo.model';

export interface ITodoState {
    todo: IEntityState<Todo>;
}

export const TODO = 'todo';

export const typeState = createFeatureSelector<ITodoState>(
    TODO
);

export const { initialState: initialTodoState, selectors, facade: todoFacadeBase } = buildFeatureState(
    Todo,
    TODO,
    typeState
);

export function todoReducer(state = initialTodoState): IEntityState<Todo> {
    return state;
}

export const todoReducers: ActionReducerMap<ITodoState> = {
    todo: todoReducer
};
